// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"38":"796619d79de9b9b7","440":"f789a1b47b3e4f9d","581":"1b83ce9aa5b3301a"}[chunkId] + ".js";
};